import matrix from './roadWorkOrders.json';

const WORK_ORDERS = matrix as Record<string, string>;

export function lookupWorkOrder(damage?: string | null, element?: string | null): string | null {
  if (!damage || !element) return null;
  return WORK_ORDERS[`${damage}||${element}`] || null;
}

export function workOrderForRecord(record: {
  roadWorkOrder?: string | null;
  roadDamageType?: string | null;
  roadElement?: string | null;
}): string | null {
  return record.roadWorkOrder || lookupWorkOrder(record.roadDamageType, record.roadElement);
}
